"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigateDTO = exports.PageViewDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const dto_factory_1 = require("../types/dto-factory");
let PageViewDTO = class PageViewDTO extends (0, dto_factory_1.DTOFactory)() {
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.MaybeUrl)(),
    (0, decorators_1.Describe)('Page view context such as URL or game screen'),
    __metadata("design:type", String)
], PageViewDTO.prototype, "page", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.MaybeUrl)(),
    (0, decorators_1.Describe)('Referrer location such as URL or game screen'),
    __metadata("design:type", String)
], PageViewDTO.prototype, "from", void 0);
PageViewDTO = __decorate([
    (0, decorators_1.Describe)('A page or screen was viewed in the application'),
    (0, decorators_1.Warning)('Consider omitting navigation in application when page views are registered')
], PageViewDTO);
exports.PageViewDTO = PageViewDTO;
let NavigateDTO = class NavigateDTO extends (0, dto_factory_1.DTOFactory)() {
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.MaybeUrl)(),
    (0, decorators_1.Describe)('From location such as URL or game screen'),
    __metadata("design:type", String)
], NavigateDTO.prototype, "from", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.MaybeUrl)(),
    (0, decorators_1.Describe)('To location such as URL or game screen'),
    __metadata("design:type", String)
], NavigateDTO.prototype, "to", void 0);
NavigateDTO = __decorate([
    (0, decorators_1.Describe)('A user navigated from A -> B, consider using for offsite navigation and CTAs'),
    (0, decorators_1.Warning)("Navigate + PageView within an application results in 'noisy' data ")
], NavigateDTO);
exports.NavigateDTO = NavigateDTO;
